import type { ComponentProps } from 'react';

import { Icon } from '#/components/Icon/Icon';

import { LegacyBorderlessButton } from './LegacyBorderlessButton';

export function LegacyChevronUpButton(
  props: ComponentProps<typeof LegacyBorderlessButton>,
) {
  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <LegacyBorderlessButton {...props}>
      <Icon name="chevron-up" size={15} />
    </LegacyBorderlessButton>
  );
}
